import { LoginTemplate } from 'common/templates/LoginTemplate';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { authActions } from 'state/auth/auth.actions';
import { AppState } from 'state/reducer';

const mapStateToProps = (state: AppState) => ({
  loading: state.auth.loading,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      onSubmit: authActions.login,
    },
    dispatch
  );

export const LoginPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginTemplate);
